import { httpBatchLink, loggerLink } from "@trpc/client";
import superjson from "superjson";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { trpc } from "./trpc";
import { env } from "./env";
import { pinLink } from "./pin-link";
import { soLeituraLink } from "./so-leitura-link";
import { orgDoVerComo, tokenDoVerComo, tratarFimDoVerComo } from "./ver-como";

/** `aoConcluirMutacao`: avisa quem está fora deste cache (o painel de /organizacoes usa pra
 *  atualizar os números da prévia, que vivem no cache da tela principal). */
export function createQueryClient(aoConcluirMutacao?: () => void) {
  return new QueryClient({
    queryCache: new QueryCache({ onError: tratarFimDoVerComo }),
    mutationCache: new MutationCache({ onSuccess: aoConcluirMutacao, onError: tratarFimDoVerComo }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}

/** `organizacaoId`: toda chamada deste cliente age nessa organização (cabeçalho `x-organizacao`),
 *  sem trocar a ativa — é o cliente dos painéis de /organizacoes. `mutacoesLiberadas`: só essas
 *  mutações passam (ficha só leitura de outra clínica). */
export function createTRPCClient(organizacaoId?: string, mutacoesLiberadas?: string[]) {
  return trpc.createClient({
    links: [
      loggerLink({
        enabled: (opts) =>
          (import.meta.env.DEV && typeof window !== "undefined") ||
          (opts.direction === "down" && opts.result instanceof Error),
      }),
      ...(mutacoesLiberadas ? [soLeituraLink(mutacoesLiberadas)] : []),
      pinLink,
      httpBatchLink({
        url: `${env.apiUrl}/api/trpc`,
        transformer: superjson,
        headers() {
          const h: Record<string, string> = {};
          const org = organizacaoId ?? orgDoVerComo();
          if (org) h["x-organizacao"] = org;
          const verComo = tokenDoVerComo();
          if (verComo) h["x-ver-como"] = verComo;
          return h;
        },
        fetch(url, options) {
          return fetch(url, { ...options, credentials: "include" });
        },
      }),
    ],
  });
}
